import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import { useEnsureEventVolunteerCompanionQuery } from '../../../../../../queries/Volunteer';
import { Checkbox } from '../../../../../components-v2/Checkbox';
import { Field, FieldContent, FieldLabel } from '../../../../../components-v2/Field';
import { Input } from '../../../../../components-v2/Input';
import { Label } from '../../../../../components-v2/Label';
import { useServerShiftDataSource } from '../../../../../pages/Volunteers/shiftDataSource';
import { EventRegistrationFormData } from '../../utils';
import { styleSheet } from './styles';
import { useDraftShiftDataSource } from './useDraftShiftDataSource';
import { VolunteerFormBuilder } from './VolunteerFormBuilder';
import { VolunteerShiftsSection } from './VolunteerShiftsSection';

interface IProps {
	surveyId?: string;
	persistedVolunteerEnabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}

export const VolunteersTab: React.FC<IProps> = ({ surveyId, persistedVolunteerEnabled, impersonationContext }) => {
	const { watch, setValue } = useFormContext<EventRegistrationFormData>();
	const enabled = watch('volunteerSettings.enabled');
	const tag = watch('volunteerSettings.volunteerTag');
	const { data: companion } = useEnsureEventVolunteerCompanionQuery({
		eventSurveyId: surveyId,
		enabled: !!enabled && !!persistedVolunteerEnabled,
		impersonationContext,
	});
	const draftSource = useDraftShiftDataSource();
	const serverSource = useServerShiftDataSource(companion?.id ?? '', impersonationContext);
	const shiftSource = companion ? serverSource : draftSource;

	return (
		<div className={css(styleSheet.root)}>
			<Field orientation='horizontal'>
				<Checkbox
					checked={enabled}
					onCheckedChange={next => setValue('volunteerSettings.enabled', next === true, { shouldDirty: true })}
				/>
				<Label>Enable volunteers for this event</Label>
			</Field>
			{enabled ? (
				<>
					<Field>
						<FieldLabel>Volunteer tag</FieldLabel>
						<FieldContent>
							<Input
								value={tag}
								onChange={e => setValue('volunteerSettings.volunteerTag', e.target.value, { shouldDirty: true })}
								placeholder='e.g. Volunteer: Gala 2026'
							/>
						</FieldContent>
					</Field>
					{!companion ? (
						<div className={css(styleSheet.notice)}>
							Shifts drafted here aren&rsquo;t saved yet &mdash; save the event with volunteers enabled to start saving
							them.
						</div>
					) : null}
					<VolunteerShiftsSection dataSource={shiftSource} />
					<VolunteerFormBuilder shiftSource={shiftSource} />
				</>
			) : null}
		</div>
	);
};
